var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconShieldInSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#5777EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.214 4.725a1.687 1.687 0 00-.429 0 2.293 2.293 0 00-.437.113l-.033.01-4.12 1.374c-.462.153-.87.288-1.183.534a2.014 2.014 0 00-.615.789c-.148.347-.148.733-.147 1.173v3.28c0 1.885 1.153 3.456 2.4 4.61 1.254 1.162 2.69 1.983 3.448 2.377l.031.016c.139.072.319.166.556.211.195.037.435.037.63 0 .237-.045.417-.139.556-.211l.03-.016c.76-.394 2.195-1.215 3.45-2.377 1.246-1.154 2.399-2.725 2.399-4.61v-3.28c0-.44.001-.826-.147-1.173a2.014 2.014 0 00-.615-.79c-.314-.245-.72-.38-1.184-.533l-4.12-1.374-.032-.01c-.121-.041-.273-.092-.438-.113z",
    fill: "#fff"
  })));
}
export default SvgIconShieldInSquare;